import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.css';
import logo from '../../../assests/logo-agrobrazil-branco.png';
export default function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer>
      <div className="footer">
        <div className="direitos">
          <p>{ t('pages.includes.footer.copyright') }</p>
        </div>
        <div className="logo">
          <img className="img-logo" src={logo} alt="LOGO"/>
        </div>
      </div>
    </footer >
  )
}